'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _reduxPromiseMiddleware = require('redux-promise-middleware');
var _constants = require('../constants');
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var defaultState = {
  options: [],
  visible: 'lookup'
};
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  switch (action.type) {
    case _constants.actionTypes.INITIALISE_ADDRESS_LOOKUP:
      {
        return state[action.name] ? state : Object.assign({}, state, _defineProperty({}, action.name, defaultState));
      }
    case _constants.actionTypes.RESET_ADDRESS_LOOKUP:
      {
        return Object.assign({}, state, _defineProperty({}, action.name, defaultState));
      }
    case _constants.actionTypes.ADDRESS_LOOKUP + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, _defineProperty({}, action.meta.name, Object.assign({}, defaultState, {
          visible: 'loading'
        })));
      }
    case _constants.actionTypes.ADDRESS_LOOKUP + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        if (!action.payload.length) {
          return Object.assign({}, state, _defineProperty({}, action.meta.name, Object.assign({}, defaultState, {
            visible: 'manual',
            error: true
          })));
        }
        return Object.assign({}, state, _defineProperty({}, action.meta.name, {
          visible: 'multiple',
          options: action.payload.map(function (address) {
            return {
              value: JSON.stringify(address),
              text: address.Text + ' ' + address.Description
            };
          })
        }));
      }
    case _constants.actionTypes.ADDRESS_LOOKUP + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, state, _defineProperty({}, action.meta.name, Object.assign({}, defaultState, {
          visible: 'manual'
        })));
      }
    case _constants.actionTypes.ADDRESS_RETRIEVE + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, _defineProperty({}, action.meta.name, Object.assign({}, defaultState, {
          visible: 'loading'
        })));
      }
    case _constants.actionTypes.ADDRESS_RETRIEVE + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        return Object.assign({}, state, _defineProperty({}, action.meta.name, {
          visible: 'details',
          options: []
        }));
      }
    case _constants.actionTypes.ADDRESS_RETRIEVE + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, state, _defineProperty({}, action.meta.name, Object.assign({}, defaultState, {
          visible: 'manual'
        })));
      }
    case '' + _constants.actionTypes.SET_ADDRESS_VIEW:
      return Object.assign({}, state, _defineProperty({}, action.name, {
        visible: action.view
      }));
    default:
      return state;
  }
};